import styled from 'styled-components';
import {
  FieldRow,
  SectionActions,
} from 'components/domain/customDomains/modal/CustomDomainModal.styles';
import theme from 'styles/theme';

export const WhiteLabelCardStyled = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 20px;
  overflow: hidden;
`;

export const WhiteLabelIntroStyled = styled.div`
  background: #eef0fb;
  padding: 16px 20px;

  p {
    color: #6b7280;
    margin: 0;
  }

  p + p {
    margin-top: 4px;
  }

  strong {
    color: #374151;
  }

  a {
    color: ${theme.colors.hostfullyPurple};
  }
`;

export const WhiteLabelBodyStyled = styled.div`
  padding: 20px;
`;

// The fields only exist while the domain is customized, so the checkbox needs to keep its
// spacing from them without inheriting the form-group margin when it stands alone.
export const WhiteLabelToggleStyled = styled.div`
  margin-bottom: 12px;
`;

// Indented like the domain section below it, so both label columns line up.
export const FaviconRowStyled = styled(FieldRow)`
  margin: 0 0 20px 25px;

  input[type='file'] {
    display: none;
  }
`;

export const FaviconControlStyled = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
`;

export const FaviconPreviewStyled = styled.div<{ $hasImage: boolean }>`
  align-items: center;
  background: ${({ $hasImage }) => ($hasImage ? '#fff' : '#f9fafb')};
  border: 1px ${({ $hasImage }) => ($hasImage ? 'solid' : 'dashed')} #d1d5db;
  border-radius: 4px;
  color: ${theme.colors.gray600};
  display: flex;
  height: 56px;
  justify-content: center;
  overflow: hidden;
  width: 56px;

  img {
    max-height: 100%;
    max-width: 100%;
  }
`;

// Sits where the section's own actions would be; the section hides them while migrating.
export const MigrationStyled = styled.div`
  margin: -13px 0 25px 25px;
`;

export const MigrationActionsStyled = styled(SectionActions)`
  margin-top: 0;
`;
